module.exports = __webpack_public_path__ + "static/media/airtable_logo.9ec134fc.png";